module.exports = __webpack_public_path__ + "img/icon_referidos_at.759a2b5f.svg";